<footer class="compact-footer">
  <div class="compact-footer-content">
    <div class="compact-footer-main">
      <div class="compact-footer-brand">
        <img
          src="assets/icons/rocket-close-logo-white.svg"
          alt="Rocket Close"
          class="rocket-close-logo"
        />
        <div class="brand-info">
          <p class="brand-description">
            {{ "compact-footer.brandDescription" | translate }}
          </p>
          <p class="copyright">
            {{ "compact-footer.copyright" | translate: { year: currentYear } }}
          </p>
        </div>
        <div class="rocket-close-product">
          <h3 class="product-title">
            {{ "compact-footer.rocketClose.title" | translate }}
          </h3>
          <p class="product-description">
            {{ "compact-footer.rocketClose.description" | translate }}
          </p>
        </div>
      </div>

      <div class="compact-footer-links">
        <div class="links-column">
          <h3 class="column-title">
            {{ "compact-footer.companyInfo.heading" | translate }}
          </h3>
          <ul class="links-list">
            @for (link of companyInfoLinks; track link.textKey) {
              <li>
                <a
                  appTrackedLink
                  [trackId]="`footer:company-info:${link.trackId}`"
                  [href]="link.url"
                  class="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ link.textKey | translate }}
                </a>
              </li>
            }
          </ul>
        </div>

        <div class="links-column">
          <h3 class="column-title">
            {{ "compact-footer.siteUse.heading" | translate }}
          </h3>
          <ul class="links-list">
            @for (link of siteUseLinks; track link.textKey) {
              <li>
                <a
                  appTrackedLink
                  [trackId]="`footer:legal:${link.trackId}`"
                  [href]="link.url"
                  class="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ link.textKey | translate }}
                </a>
              </li>
            }
          </ul>
        </div>

        <div class="links-column">
          <h3 class="column-title">
            {{ "compact-footer.followUs.heading" | translate }}
          </h3>
          <div class="social-links">
            @for (social of socialLinks; track social.name) {
              <a
                appTrackedLink
                [trackId]="`footer:social:${social.trackId}`"
                [href]="social.url"
                class="social-link"
                [attr.aria-label]="social.name"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  [src]="social.icon"
                  [alt]="social.name"
                  class="social-icon"
                />
              </a>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
